import { red, green, grey } from "@mui/material/colors";
import { GameLogItemProps, GameLogItemSourceProps } from "./types";

export function getResultColor(result: string): string {
  if (result.startsWith("W")) return green[500];
  if (result.startsWith("L")) return red[500];
  return grey[500];
}

export function getGameResult(
  homeScore: number,
  awayScore: number,
  isHome: boolean
): string {
  const teamScore = isHome ? homeScore : awayScore;
  const opponentScore = isHome ? awayScore : homeScore;
  const won = teamScore > opponentScore;

  return `${won ? "W" : "L"} ${teamScore}-${opponentScore}`;
}

export function transformSourceGameLog(
  gameLog: GameLogItemSourceProps
): GameLogItemProps {
  return {
    ...gameLog,
    homeScore: gameLog.isHome ? gameLog.teamScore : gameLog.opponentScore,
    awayScore: gameLog.isHome ? gameLog.opponentScore : gameLog.teamScore,
  };
}
